<template>
  <div>
    <el-dialog :title="'号码手动录入'" :visible.sync="visible" width="30%"
      :before-close="handleClose" :close-on-click-modal="false">
      <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px">
          <el-form-item label="自动复机:" v-show="dataForm.IsStop">
            <el-select v-model="dataForm.RepeatedStatus" placeholder="自动复机">
              <el-option label="手动复机" value="None"></el-option>
              <el-option label="自动复机（1天）" value="OneDay"></el-option>
              <el-option label="自动复机（2天）" value="TwoDay"></el-option>
              <el-option label="自动复机（3天）" value="ThreeDay"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="停机类型:" v-show="dataForm.IsStop">
            <el-select v-model="dataForm.OperationType" placeholder="停机类型">
              <el-option label="手工停机" value="手工停机"></el-option>
              <el-option label="黑名单停机" value="黑名单停机"></el-option>
              <el-option label="欠费停机" value="欠费停机"></el-option>
              <el-option label="未续费停机" value="未续费停机"></el-option>
              <el-option label="质检停机" value="质检停机"></el-option>
              <el-option label="投诉停机" value="投诉停机"></el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="号码录入:" prop="tellist">
          <el-input type="textarea" placeholder="请输入号码
180***8123
180***7234
..." v-model="dataForm.tellist" :autosize="{ minRows: 5 }">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" :loading="confirmLoading" @click="ok">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      type: 1,
      confirmLoading: false,
      dataForm: {
        tellist: null,
        RepeatedStatus: 'None',
        OperationType: '手工停机',
        IsStop: true,
      },
      rules: {
        tellist: {
          required: true,
          message: "请录入手机号",
          trigger: "change",
        },
      },
    };
  },
  methods: {
    init(IsStop) {
      this.dataForm.IsStop = IsStop;
      this.visible = true;
      this.type = this.dataForm.IsStop?1:2;
      this.dataForm.RepeatedStatus = this.dataForm.RepeatedStatus
      this.dataForm.OperationType = this.dataForm.OperationType
    },
    handleClose() {
      this.$refs.dataForm.resetFields();
      this.visible = false;
      this.dataForm.id = "";
    },
    ok() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const tellist = this.dataForm.tellist.split("\n").filter((v) => !!v);
          if (tellist.length == 0) return this.$message.error("没有有效数据");
          this.$http({
            url: "/api/FilterCaller/StopOrOpen",
            method: "post",
            data: {

              tellist: tellist,
              type: this.dataForm.IsStop?1:2,
              RepeatedStatus: this.dataForm.RepeatedStatus,
              OperationType: this.dataForm.IsStop ? this.dataForm.OperationType : "复机"
            },
          })
            .then((res) => {
              if (res.data && res.data.success) {
                this.confirmLoading = false;
                this.$message.success(res.data.msg || "操作成功");
                this.handleClose();
                this.$emit("ok");
              }
            })
            .finally(() => (this.confirmLoading = false));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**
     * 下载模板
     */
    download() {
      const url = "/号码导入模板.xlsx";
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
  },
};
</script>

<style></style>